import SignUp from "../features/Auth/Components/SignUp";

function SignUpPage() {
    return(
        <div>
            <SignUp/>
        </div>
    )
}
export default SignUpPage;